import { compose } from 'utils/compose';
import { useNavigate } from 'react-router-dom';
import { inject, observer } from 'mobx-react';

import { Box, Typography, DialogContent } from '@mui/material';
import { CheckCircleOutline as CheckCircleOutlineIcon } from '@mui/icons-material';

import { useStyles } from '../styles';
import Header from 'components/Header';
import { DialogActionButton, DialogFooter } from 'components/Dialog';

import menuItems from 'constants/menuItems';
import withMediaQuery from 'constants/mediaQuery';

function DialogStepLast({ store, mediaQuery, closeDialog }) {
  const classes = useStyles();
  const navigate = useNavigate();

  const nextStep = () => {
    store.deliveryStore.processNextStep();
    navigate(`/${store.deliveryStore.trackingCode}/edit`);
  };

  return (
    <Box>
      {mediaQuery.isMobile && <Header menuItems={menuItems} />}
      <DialogContent>
        <Typography sx={classes.lastDialogText}>
          <CheckCircleOutlineIcon sx={{ ...classes.inlineIcon, ...classes.greenIcon, fontSize: 40 }} />
          <Box component="span" sx={{ ...classes.darkGrayText, fontSize: 18, fontWeight: 600 }}>
            You're all set! Please proceed to Manage Delivery
          </Box>
        </Typography>
      </DialogContent>
      <DialogFooter>
        <DialogActionButton onClick={() => closeDialog()} variant="outlined" color="primary" disableElevation>
          Cancel
        </DialogActionButton>
        <DialogActionButton onClick={nextStep} variant="contained" color="primary" disableElevation>
          OK
        </DialogActionButton>
      </DialogFooter>
    </Box>
  );
}

const DialogStepLastCompose = compose(inject('store'), observer)(DialogStepLast);

export default withMediaQuery()(DialogStepLastCompose);
